import Swiper, {Navigation} from "../../assets/.npm/node_modules/swiper";

export default () => {
    const tlSwiper = new Swiper('.tl-swiper', {
        modules: [Navigation],
        slidesPerView: 1.1,
        spaceBetween: 36,
        speed: 600,
        navigation: {
          nextEl: '.tl-next',
          prevEl: '.tl-prev',
        },
        breakpoints: {
          640: { slidesPerView: 2, spaceBetween: 40 },
          992: { slidesPerView: 3, spaceBetween: 56 },
        },
    });
};
  